import { useContext } from 'react';
import VehicleContext from '~/context/vdp/VehicleContext';
import useShowVaultWhyBuyContent from '../useHasVaultWhyBuyData';

type Result = {
  isLoaded: boolean;
  isLoading: boolean;
};

export default function useGetWhyBuyDataLoaded(): Result {
  const vaultWhyBuyContentExists = useShowVaultWhyBuyContent();
  const {
    ymmtWhyBuy: { isLoaded, isLoading }
  } = useContext(VehicleContext);

  return vaultWhyBuyContentExists
    ? {
        isLoaded: true,
        isLoading: false
      }
    : {
        isLoaded: isLoaded,
        isLoading: isLoading
      };
}
